import type { UploadDto } from "../../../autogen/bff-api";

// The S3 POST policy is base64 JSON whose `expiration` ends the window in which storage accepts the file.
export const uploadWindowClosesAt = (upload: Pick<UploadDto, "policy">): number | null => {
  try {
    const closesAt = Date.parse(JSON.parse(atob(upload.policy)).expiration);
    return Number.isNaN(closesAt) ? null : closesAt;
  } catch {
    return null;
  }
};
